<template>
  <TrainerLayout>
    <section class="mx-0 mt-14">
      <p class="font-semibold text-3xl leading-10 tracking-tight">Settings</p>
      <!-- <div class="flex my-8" :class="{ '-ml-4': currentTab !== 'Basics' }">
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{ 'bg-green-light text-white': currentTab === 'Basics' }"
          @click="changeTab('Basics')"
        >
          Basics
        </button>
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{
            'bg-green-light text-white': currentTab === 'PaymentSettings',
          }"
          @click="changeTab('PaymentSettings')"
        >
          Payment settings
        </button>
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{ 'bg-green-light text-white': currentTab === 'Account' }"
          @click="changeTab('Account')"
        >
          Account
        </button>
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{
            'bg-green-light text-white': currentTab === 'Notification',
          }"
          @click="changeTab('Notification')"
        >
          Notification
        </button>
      </div> -->
      <!-- <div class="grid grid-cols-3 gap-6 pt-5">
        <div class="bg-white shadow-md p-6 rounded-lg">
          <div class="flex pb-5">
            <img :src="require(`@/assets/svg/GroovePay.svg`)" alt="Shield" />
            <img
              :src="require(`@/assets/svg/Visa-Mastercard.svg`)"
              alt="Shield"
              class="pl-5"
            />
          </div>
          <p class="text-base font-medium leading-4 text-gray-700">
            The best and most affordable way to accept credit cards
          </p>
          <button
            class="w-full bg-green-light text-white font-semibold rounded-lg py-2 mt-16 focus:outline-none"
          >
            Connect
          </button>
        </div>
        <div class="bg-white shadow-md p-6 rounded-lg">
          <img
            :src="require(`@/assets/svg/Stripe.svg`)"
            alt="Shield"
            class="pb-5"
          />
          <p class="text-base font-medium leading-4 text-gray-700">
            The best and most affordable way to accept credit cards
          </p>
          <button
            class="w-full bg-green-light text-white font-semibold rounded-lg py-2 mt-16 focus:outline-none"
          >
            Connect
          </button>
        </div>
        <div class="bg-white shadow-md p-6 rounded-lg">
          <img
            :src="require(`@/assets/svg/PayPal.svg`)"
            alt="Shield"
            class="pb-5"
          />
          <p class="text-base font-medium leading-4 text-gray-700">
            The best and most affordable way to accept credit cards
          </p>
          <button
            class="w-full bg-green-light text-white font-semibold rounded-lg py-2 mt-16 focus:outline-none"
          >
            Connect
          </button>
        </div>
      </div> -->
      <div class="space-y-4 text-gray-700">
        <div class="flex flex-wrap">
          <div class="w-full">
            <label class="block mb-1">Current password</label>
            <input
              class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              type="password"
              v-model="$v.currentPassword.$model"
              :class="{ 'border-red-500': $v.currentPassword.$error }"
            />
            <div v-if="$v.currentPassword.$error">
              <span
                class="text-xs text-red-700"
                v-if="!$v.currentPassword.required"
              >
                Password is required
              </span>
              <span
                class="text-xs text-red-700"
                v-if="!$v.currentPassword.minLength"
              >
                Password minlength is 8
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full">
            <label class="block mb-1">New password</label>
            <input
              class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              type="password"
              v-model="$v.newPassword.$model"
              :class="{ 'border-red-500': $v.newPassword.$error }"
            />
            <div v-if="$v.newPassword.$error">
              <span
                class="text-xs text-red-700"
                v-if="!$v.newPassword.required"
              >
                Password is required
              </span>
              <span
                class="text-xs text-red-700"
                v-if="!$v.newPassword.minLength"
              >
                Password minlength is 8
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full">
            <label class="block mb-1">Confirm password</label>
            <input
              class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              type="password"
              v-model="$v.confirmPassword.$model"
              :class="{ 'border-red-500': $v.confirmPassword.$error }"
            />
            <div v-if="$v.confirmPassword.$error">
              <span
                class="text-xs text-red-700"
                v-if="!$v.confirmPassword.required"
              >
                Password is required
              </span>
              <span
                class="text-xs text-red-700"
                v-if="!$v.confirmPassword.sameAsPassword"
              >
                Confirm Password is not same as Password
              </span>
            </div>
          </div>
        </div>
        <div class="inline-flex float-right space-x-4">
          <button
            type="button"
            @click="$router.go(-1);"
            class="h-10 px-5 text-green-light transition-colors duration-150 bg-white rounded-lg focus:shadow-outline hover:bg-green-light hover:text-white ring-1 ring-green-light"
          >
            Cancel
          </button>

          <button
            type="submit"
            class="h-10 px-5 text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-dark ring-1 ring-green-light"
            @click="onclickChangePassword"
          >
            Save
          </button>
        </div>
      </div>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import { mapActions } from "vuex";
import { required, sameAs, minLength } from "vuelidate/lib/validators";

export default {
  name: "TrainerSettings",
  components: {
    TrainerLayout,
  },
  data() {
    return {
      currentTab: "Basics",
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
    };
  },
  validations: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
      minLength: minLength(8),
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs("newPassword"),
    },
  },
  methods: {
    ...mapActions(["postChangePassword"]),

    changeTab(tab) {
      this.currentTab = tab;
    },

    async onclickChangePassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          old_password: this.currentPassword,
          new_password: this.newPassword,
          confirm_password: this.confirmPassword,
        };
        await this.postChangePassword(data).then(() => {
          this.$router.go(-1);
        })
      }
    },
  },
};
</script>